import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import VueMqtt from "vue-mqtt";
import VueCookies from "vue-cookies";

Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VueMqtt, "wss://13share.me:1885", {
  username: "devicemgr",
  password: "mqtt@13techart"
});

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
